import { UI_PRIMITIVES } from '@/core/constants/uiColors';
import CalendarBookAppointmentSvg from '@assets/images/svg/calendar-book-appointment.svg';
import React from 'react';
import { View } from 'react-native';

export interface CalendarBookAppointmentIconProps {
    size?: number;
    color?: string;
}

export function CalendarBookAppointmentIcon({ size = 24, color = UI_PRIMITIVES.bluePrimary }: Readonly<CalendarBookAppointmentIconProps>) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <CalendarBookAppointmentSvg width={size} height={size} color={color} />
        </View>
    );
}

export default CalendarBookAppointmentIcon;
